export const optionalFields = new Set([
  "spouse_name",
  "secondary_email",
  "additional_phones",
  "spouse_ssn",
  "spouse_date_birth",
  "dba",
]);

export const labelMappingQuickbooks = {
  type: "Type",
  username: "Username",
  password: "Password",
};

export const hiddenQuickbooksFields = new Set(["id"]);

export const personFilingStatusOptions = [
  { value: "1040", label: "1040" },
  { value: "1040NR", label: "1040NR" },
  { value: "1040NR - 5472", label: "1040NR - 5472" },
];

export const filingDetailsOptions = [
  { value: "Single", label: "Single" },
  { value: "Married Filing Jointly", label: "Married Filing Jointly" },
  { value: "Married Filing Separately", label: "Married Filing Separately" },
  { value: "Head of Household", label: "Head of Household" },
  { value: "Surviving Spouse", label: "Surviving Spouse" },
];

export const businessfilingStatusOptions = [
  { value: "1120", label: "1120" },
  { value: "1120 - 5472", label: "1120 - 5472" },
  { value: "5471", label: "5471" },
  { value: "1120S", label: "1120S" },
  { value: "1065", label: "1065" },
  { value: "1065 - 8805/04", label: "1065 - 8805/04" },
  { value: "990", label: "990" },
  { value: "990 EZ", label: "990 EZ" },
  { value: "1042S", label: "1042S" },
  { value: "Sch C", label: "Sch C" },
  { value: "SMLLC/1040", label: "SMLLC/1040" },
  { value: "SMLLC/1120", label: "SMLLC/1120" },
  { value: "SMLLC/1120S ", label: "SMLLC/1120S " },
  { value: "SMLLC/1065", label: "SMLLC/1065" },
  { value: "SMLLC/1040-NR", label: "SMLLC/1040-NR" },
];

export const contactMethodOptions = [
  { value: "Email", label: "Email" },
  { value: "Phone", label: "Phone" },
];

export const statusOptions = [
  { value: "Lead", label: "Lead" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

export const internationalOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const usStateOptions = [
  { value: "Alabama", label: "Alabama" },
  { value: "Alaska", label: "Alaska" },
  { value: "Arizona", label: "Arizona" },
  { value: "Arkansas", label: "Arkansas" },
  { value: "California", label: "California" },
  { value: "Colorado", label: "Colorado" },
  { value: "Connecticut", label: "Connecticut" },
  { value: "Delaware", label: "Delaware" },
  { value: "Florida", label: "Florida" },
  { value: "Georgia", label: "Georgia" },
  { value: "Hawaii", label: "Hawaii" },
  { value: "Idaho", label: "Idaho" },
  { value: "Illinois", label: "Illinois" },
  { value: "Indiana", label: "Indiana" },
  { value: "Iowa", label: "Iowa" },
  { value: "Kansas", label: "Kansas" },
  { value: "Kentucky", label: "Kentucky" },
  { value: "Louisiana", label: "Louisiana" },
  { value: "Maine", label: "Maine" },
  { value: "Maryland", label: "Maryland" },
  { value: "Massachusetts", label: "Massachusetts" },
  { value: "Michigan", label: "Michigan" },
  { value: "Minnesota", label: "Minnesota" },
  { value: "Mississippi", label: "Mississippi" },
  { value: "Missouri", label: "Missouri" },
  { value: "Montana", label: "Montana" },
  { value: "Nebraska", label: "Nebraska" },
  { value: "Nevada", label: "Nevada" },
  { value: "New Hampshire", label: "New Hampshire" },
  { value: "New Jersey", label: "New Jersey" },
  { value: "New Mexico", label: "New Mexico" },
  { value: "New York", label: "New York" },
  { value: "North Carolina", label: "North Carolina" },
  { value: "North Dakota", label: "North Dakota" },
  { value: "Ohio", label: "Ohio" },
  { value: "Oklahoma", label: "Oklahoma" },
  { value: "Oregon", label: "Oregon" },
  { value: "Pennsylvania", label: "Pennsylvania" },
  { value: "Rhode Island", label: "Rhode Island" },
  { value: "South Carolina", label: "South Carolina" },
  { value: "South Dakota", label: "South Dakota" },
  { value: "Tennessee", label: "Tennessee" },
  { value: "Texas", label: "Texas" },
  { value: "Utah", label: "Utah" },
  { value: "Vermont", label: "Vermont" },
  { value: "Virginia", label: "Virginia" },
  { value: "Washington", label: "Washington" },
  { value: "West Virginia", label: "West Virginia" },
  { value: "Wisconsin", label: "Wisconsin" },
  { value: "Wyoming", label: "Wyoming" },
];

export const accountingMethodOptions = [
  { value: "Cash Basis", label: "Cash Basis" },
  { value: "Accrual Basis", label: "Accrual Basis" },
];

export const languageOptions = [
  { value: "Spanish", label: "Spanish" },
  { value: "English", label: "English" },
];

export const quickbooksTypeOptions = [
  { value: "Online", label: "Online" },
  { value: "Desktop M", label: "Desktop M" },
  { value: "Desktop P", label: "Desktop P" },
];

export const activityTrackingOptions = [
  { value: "Bookkeeping", label: "Bookkeeping" },
  { value: "Bookkeeping Project", label: "Bookkeeping Project" },
  { value: "QB Clean Up", label: "QB Clean Up" },
  { value: "Tax Planning", label: "Tax Planning" },
];

export const dependantRelationshipOptions = [
  { value: "Son", label: "Son" },
  { value: "Daughter", label: "Daughter" },
  { value: "Mother", label: "Mother" },
  { value: "Father", label: "Father" },
  { value: "In Law", label: "In Law" },
  { value: "Brother/Sister", label: "Brother/Sister" },
];

export const serviceOptions = [
  { value: "Personal Taxes", label: "Personal Taxes" },
  { value: "Business Taxes", label: "Business Taxes" },
  { value: "New Company", label: "New Company" },
  { value: "Sales Taxes", label: "Sales Taxes" },
  { value: "POA", label: "POA" },
  { value: "Monthly Bookkeeping", label: "Monthly Bookkeeping" },
  { value: "Bookkeeping Project", label: "Bookkeeping Project" },
];

export const leadStatusOptions = [
  { value: "Open", label: "Open" },
  { value: "Waiting for Documents", label: "Waiting for Documents" },
  { value: "Ready for Quote", label: "Ready for Quote" },
  { value: "Waiting on Acceptance", label: "Waiting on Acceptance" },
  { value: "Closed", label: "Closed" },
  { value: "Lost", label: "Lost" },
];

export const urgencyOptions = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
];

export const referralOptions = [
  { value: "Online", label: "Online" },
  { value: "Client", label: "Client" },
  { value: "Staff", label: "Staff" },
];

export const accountantOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const teamMembers = [
  "Thomacina",
  "Angie",
  "Gerry",
  "Carlos",
  "Veronica",
  "Valeria",
  "Maria",
  "Monica",
  "Farah",
  "Daniel",
  "Eddie",
];

export const CHIP_STYLE_MAP = {
  call: "bg-blue-100 text-blue-800",
  email: "bg-green-100 text-green-800",
  meeting: "bg-purple-100 text-purple-800",
  proposal: "bg-amber-100 text-amber-800",
  contract: "bg-rose-100 text-rose-800",
  payment: "bg-teal-100 text-teal-800",
  default: "bg-gray-100 text-gray-800",
};

export const DATE_WITH_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export const DATE_ONLY_FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
});

export const ISO_DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

export const MONTHS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const employeeGenderOptions = [
  { value: "Female", label: "Female" },
  { value: "Male", label: "Male" },
  { value: "Other", label: "Other" },
];

export const employeeStatusOptions = [
  { value: "Active", label: "Active" },
  { value: "Terminated", label: "Terminated" },
  { value: "On Leave", label: "On Leave" },
];

export const employeeTypeOptions = [
  { value: "Full-time", label: "Full-time" },
  { value: "Part-time", label: "Part-time" },
  { value: "Contract", label: "Contract" },
  { value: "Intern", label: "Intern" },
];

export const employeeLevelOptions = [
  { value: "Employee", label: "Employee" },
  { value: "Manager", label: "Manager" },
  { value: "Partner", label: "Partner" },
];

export const employeeDepartmentOptions = [
  { value: "Sales", label: "Sales" },
  { value: "Operations", label: "Operations" },
  { value: "HR", label: "HR" },
  { value: "Management", label: "Management" },
  { value: "Bookkeeping", label: "Bookkeeping" },
  { value: "Business Management", label: "Business Management" },
  { value: "Taxes", label: "Taxes" },
];

export const employeeCompensationOptions = [
  { value: "Salary", label: "Salary" },
  { value: "Hourly", label: "Hourly" },
];

export const vacationTypeOptions = [
  { value: "Vacation", label: "Vacation" },
  { value: "Sick Leave", label: "Sick Leave" },
  { value: "Personal Leave", label: "Personal Leave" },
  { value: "Unpaid Leave", label: "Unpaid Leave" },
  { value: "Half a Day", label: "Half a Day" },
  { value: "Jury Duty", label: "Jury Duty" },
];

export const vacationStatusOptions = [
  { value: "Active", label: "Active" },
  { value: "Terminated", label: "Terminated" },
  { value: "On Leave", label: "On Leave" },
];
